<template>
  <div>
    <v-layout justify-center>
      <v-flex xs12 sm10 md8 lg6 xl4>
        <v-card flat outlined flat class="" @click="toggleAnswer">
          <v-card flat class="pa-5">
            <div v-html="question" class="blue--text">
            </div>
            <img width="85%" style="max-height:500px;" :src='question_image' v-if="question_image">
            <div v-html="answer" v-if="showAnswer">
            </div>
            <img width="85%" style="max-height:500px;" :src='answer_image' v-if="showAnswer && answer_image">
          </v-card>
        </v-card>
        <v-card color="" flat outlined class="px-5 py-3" v-if="showAnswer && learnMore != ''" @click="showLearnMore = !showLearnMore">
          <div class="purple--text" v-if="showLearnMore == false"> Tap/click to learn more</div>
          <div v-if="showAnswer && showLearnMore">
            <div v-html="learnMore"></div>
            <img width="85%" :src='learnMore_image' v-if="showAnswer && learnMore_image != ''">
          </div>
        </v-card>
      </v-flex>

    </v-layout>
  </div>


</template>

<script>
export default {
  name: 'cardQuestionAnswer',
  props: ['card'],
  data() {
    return {
      cardId: null,
      showAnswer: false,
      question: null,
      answer: null,
      question_image: null,
      answer_image: null,

      showLearnMore: false,
      learnMore: null,
      learnMore_image: null

    }
  },
  watch: {
    card: function() {
      this.showAnswer = false
      this.showLearnMore = false
      //this.$emit('answerState', this.showAnswer)
      this.question = this.card.question
      this.answer = this.card.answer
      this.question_image = this.card.question_image
      this.answer_image = this.card.answer_image
      this.learnMore = this.card.learnMore
      this.learnMore_image = this.card.learnMore_image
    }
  },
  mounted() {
    this.cardId = this.card.cardId
    this.question = this.card.question
    this.answer = this.card.answer
    this.question_image = this.card.question_image
    this.answer_image = this.card.answer_image
    this.learnMore = this.card.learnMore
    this.learnMore_image = this.card.learnMore_image

    //answer image caching
    // if (this.card.answer_image.length > 0) {
    //   let answerImage = new Image()
    //   answerImage.src = this.card.answer_image
    // }

    this.$nextTick(function () {
        window.addEventListener('keyup', event => {
          if (this.$store.state.enableHotkeys) {
            if (event.key == '1' && this.showAnswer == true) {
              this.$emit('hotkey', 1)
            }
            else if (event.key == '2' && this.showAnswer == true) {
              this.$emit('hotkey', 2)
            }
            else if (event.key == '3' && this.showAnswer == true) {
              this.$emit('hotkey', 3)
            }
            else if (event.key == 'z' && this.showAnswer == false) {
              this.$emit('hotkey', 'z')
            }
            else if (event.key == ' ') {
              this.toggleAnswer()
              this.$emit('hotkey', 'space')

            }

          }

        })
    });

  },
  methods: {
    toggleAnswer() {
      this.showAnswer = !this.showAnswer
      this.$emit('answerState', this.showAnswer)
    },

  }

}
</script scoped>

<style>
img {
  max-width:100%;
  height: auto;
}

</style>
